import { GUEST_LOGIN, GUEST_LOGOUT, GUEST_SUGGEST_ACCOUNT } from "../Constants/guestconstants";

export const guestLogin = (email = "") => (dispatch) => {
  const guestInfo = { isGuest: true, email };
  dispatch({ type: GUEST_LOGIN, payload: email });
  localStorage.setItem("guestInfo", JSON.stringify(guestInfo));
};

export const guestLogout = () => (dispatch) => {
  dispatch({ type: GUEST_LOGOUT });
  localStorage.removeItem("guestInfo");
};

export const guestSuggestAccount = (email) => (dispatch) => {
  dispatch({ type: GUEST_SUGGEST_ACCOUNT, payload: email });
};